// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styledCheckbox_wrapper__2YlbE","invalid":"styledCheckbox_invalid__1SP6P"};